import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-modal-products-voucher',
  templateUrl: './modal-products-voucher.component.html',
  standalone: false,
})
export class ModalProductsVoucherComponent {
  public products = [];

  constructor(@Inject(DIALOG_DATA) public data: any, private dialogRef: DialogRef) {
    this.products = data.products.map((product) => ({ ...product, checked: false }));
  }

  public selectAll() {
    this.products.forEach((product) => (product.checked = true));
  }

  public deselectAll() {
    this.products.forEach((product) => (product.checked = false));
  }

  public allSelected(): boolean {
    return this.products.every((product) => product.checked);
  }

  public anySelected(): boolean {
    return this.products.some((product) => product.checked);
  }

  public onSave() {
    this.dialogRef.close(this.products.filter((product) => product.checked));
  }

  public onClose() {
    this.dialogRef.close();
  }
}
